module.exports = __webpack_public_path__ + "fonts/fraunces.woff2";